import { render } from "./TabVentana.vue?vue&type=template&id=3c07b38f&scoped=true"
import script from "./TabVentana.vue?vue&type=script&lang=js"
export * from "./TabVentana.vue?vue&type=script&lang=js"

import "./TabVentana.vue?vue&type=style&index=0&id=3c07b38f&scoped=true&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c07b38f"]])

export default __exports__